/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.TaxRefundMatchingResponseDto>>;
export function request(
  params: API.tms.taxRefundMatching.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/taxRefundMatching/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
